import Sticky from "react-stickynode"
import { useTranslation } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import dynamic from "next/dynamic"
import MetaData from "@/common/components/MetaData"
import SectionLine from "@/common/components/_UI/SectionLine"

import ComplianceLiteDark from "@/common/assets/image/products/icons/ComplianceLiteDark.svg"
import AISummary from "@/common/assets/image/products/compliance/lite/AISummary.webp"
import CMPAssistant from "@/common/assets/image/products/compliance/lite/CMPAssistant.webp"

const NavbarNew = dynamic(import("@/containers/common/NavbarNew"))

import { DarkBGWrapper, LayoutWrapper } from "@/common/components/LayoutStyle"
import ProductCTA from "@/common/components/ProductCTA"
import ProductViewMore from "@/common/components/ProductViewMore"
import { ProductBanner } from "@/common/components/ProductBanner"

import { ProductNames, SolutionNames } from "@/common/data/Products"
import Footer from "@/containers/common/FooterNew"
import NextImg from "@/common/components/NextImg"

const ComplianceLitePage = () => {
  const { t } = useTranslation(["complianceLite"])
  const { t: commonT } = useTranslation(["common"])

  return (
    <>
      <MetaData
        title={t("meta.title")}
        description={t("meta.description")}
        url={t("meta.url")}
        image="https://storage.googleapis.com/kryptogo-official-website-public/og-logo.webp"
        languageAlternates={[
          {
            hrefLang: "en-US",
            href: "https://www.kryptogo.com/products/compliance-lite"
          },
          {
            hrefLang: "zh-TW",
            href: "https://www.kryptogo.com/tw/products/compliance-lite"
          },
          {
            hrefLang: "zh-CN",
            href: "https://www.kryptogo.com/cn/products/compliance-lite"
          },
          {
            hrefLang: "ja-JP",
            href: "https://www.kryptogo.com/ja/products/compliance-lite"
          }
        ]}
      />

      <Sticky top={0} innerZ={1000} activeClass="sticky-active">
        <NavbarNew />
      </Sticky>
      <DarkBGWrapper></DarkBGWrapper>
      <LayoutWrapper>
        <ProductBanner
          icon={ComplianceLiteDark.src}
          bannerType={ProductNames.ComplianceLite}
          title={t("Banner.productName")}
          titleh1={t("Banner.title")}
          description={t("Banner.description")}
        />
        <SectionLine />
        <ProductBanner
          short
          paddingTop="0"
          title={t("Desc.1.productName")}
          titleType="primary"
          titleh3={t("Desc.1.title")}
          titleh3Type="normal"
          description={t("Desc.1.content")}
          comp2={<NextImg src={AISummary.src} />}
        />
        <ProductBanner
          short
          paddingTop="0"
          title={t("Desc.2.productName")}
          titleType="primary"
          titleh3={t("Desc.2.title")}
          titleh3Type="normal"
          description={t("Desc.2.content")}
          comp2={<NextImg src={CMPAssistant.src} />}
        />
        <ProductCTA
          title={t("CTA.title")}
          desc={t("CTA.desc")}
          primaryButton={{ text: t("CTA.button") }}
        />
        <ProductViewMore
          commonT={commonT}
          title={commonT("ViewMore.title")}
          tab={[
            {
              name: commonT("ViewMore.products"),
              content: [
                ProductNames.ComplyFlow,
                ProductNames.CompliancePro,
                ProductNames.User360
              ]
            },
            {
              name: commonT("ViewMore.solutions"),
              content: [SolutionNames.Defi]
            }
          ]}
          actionText={commonT("ViewMore.allProducts")}
        ></ProductViewMore>
        <Footer />
      </LayoutWrapper>
    </>
  )
}

export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      "common",
      "contactUs",
      "compliance",
      "complianceLite"
    ]))
  }
})

export default ComplianceLitePage
